var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 10.75H2.25M2.25 10.75C2.25 10.75 4.75 14.25 8.5 14.25C11.952 14.25 14.75 11.75 14.75 8.75M2.25 10.75V14.25M11.75 5.25H14.75M14.75 5.25C14.75 5.25 12.25 1.75 8.5 1.75C5.048 1.75 2.25 4.25 2.25 7.25M14.75 5.25V1.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRefresh);
export default __webpack_public_path__ + "static/media/whiteRefresh.48c995f4b8170a05a33c18bd056db567.svg";
export { ForwardRef as ReactComponent };